import CTNAppHeader from '@ctn/ui/components/ctn-app-header';
import CTNButton from '@ctn/ui/components/ctn-button';
import { useLocation, useNavigate } from 'react-router-dom';

import { useDirtyForm } from '@/context/dirtyForm.context';

import { ROUTES } from '@/constants/routes.constants';

import { LogoPNPrivate, LogoPNPublic } from './parts';


const HeaderPublic = ({ isButtonBack }: { readonly isButtonBack?: boolean }) => {
	const { checkDirtyForm } = useDirtyForm();
	const location = useLocation();
	const datos = location.state as {origin: string} | undefined;
	const navigate = useNavigate();
	const goHome = () => (datos?.origin === 'private' ? navigate(ROUTES.HOME) : navigate(ROUTES.PORTADA));


	return (
		<div className="o-layout__header">
			<CTNAppHeader
				className="c-pnp-header c-pnp-header--sm"
				title={(datos?.origin === 'private' ? (
					<LogoPNPrivate
						onClick={() => {
							checkDirtyForm({
								action() {
									navigate(ROUTES.HOME);
								},
							});
						}}
					/>
				) : (
					<LogoPNPublic onClick={goHome} />
				)) as unknown as string}
				isMenuButton={false}
			>
				{isButtonBack && <CTNButton mode="secondary" variant="ghost" label="Volver a pantalla de inicio" onClick={goHome} />}
			</CTNAppHeader>
		</div>
	);
};

export default HeaderPublic;
